// @ts-nocheck
import * as React from "react";

const LogOut: React.FC = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 2C3.55229 2 4 1.55229 4 1C4 0.447715 3.55229 0 3 0H1C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447715 16 1 16H3C3.55228 16 4 15.5523 4 15C4 14.4477 3.55228 14 3 14H2V2H3ZM16.82 7.42L14 3.42C13.6816 2.97119 13.0604 2.86393 12.61 3.18V3.18C12.1577 3.49694 12.048 4.12052 12.3649 4.57282C12.3666 4.57522 12.3683 4.57762 12.37 4.58L14.09 7H6C5.44771 7 5 7.44772 5 8C5 8.55229 5.44771 9 6 9H14L12.2 11.4V11.4C11.8686 11.8418 11.9582 12.4686 12.4 12.8V12.8C12.5731 12.9298 12.7836 13 13 13C13.3148 13 13.6111 12.8518 13.8 12.6L16.8 8.6C17.0628 8.25295 17.0709 7.77576 16.82 7.42V7.42Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(LogOut);
